import React from "react";
import { FormattedMessage } from "react-intl";
import type { Billing } from "src/billings/objects/Billing";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import { StatusFormatter } from "src/shared/formatters/StatusFormatter";

export type BillingsLabelProps = IRaangeLabelWithFAProps;

export const BillingsLabel = (props: BillingsLabelProps) => {
  return (
    <RaangeLabel fa="building" {...props}>
      <FormattedMessage id="billings" />
    </RaangeLabel>
  );
};

interface BillingProps {
  billing: Billing;
}

export const BillingExportType = ({
  billing: { exportType },
}: BillingProps) => {
  switch (exportType) {
    case "CSV_UNICODE":
      return <FormattedMessage id="billings.exportType.CSV_UNICODE" />;
    default:
      return <>{exportType}</>;
  }
};

export const BillingExportStatus = ({
  billing: { billingExportStatus },
}: BillingProps) => {
  switch (billingExportStatus) {
    case "IN_PROGRESS":
      return (
        <StatusFormatter status="warning">
          <FormattedMessage id="billings.billingExportStatus.IN_PROGRESS" />
        </StatusFormatter>
      );
    default:
      return <>{billingExportStatus}</>;
  }
};
